<script lang="ts">
    import { onMount } from 'svelte'
    import {RampInstantSDK} from '@ramp-network/ramp-instant-sdk'

    export let currency
    export let walletAddress
    export let modalWindowStatus

    let containerNode

    const assets = { NEAR: 'NEAR', USDT: 'MATIC', MATIC: 'MATIC' }

    onMount(() => {
        if (assets[currency.toUpperCase()]) {
            new RampInstantSDK({
                hostAppName: 'Realis.Network',
                hostLogoUrl: 'https://i.imgur.com/8W940jN.jpg',
                hostApiKey: process.env.RAMP_API_KEY,
                variant: 'embedded-mobile',
                userAddress: walletAddress,
                containerNode: containerNode,
                swapAsset: currency ? assets[currency.toUpperCase()]+'_'+currency.toUpperCase() : undefined
            }).on('*', (event) => {
                if (event.type === 'WIDGET_CLOSE') {
                    modalWindowStatus = false
                }
            }).show()
        }
    })
</script>

<div class="widget-wrapper">
    {#if !assets[currency.toUpperCase()]}
        This currency is not available for purchase
    {:else}
        <div bind:this={containerNode} class="widget"></div>
    {/if}
</div>

<style>
    .widget-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        overflow: hidden;
        border-radius: 10px;
    }

    .widget {
        width: 460px;
        height: 667px;
        position: relative;
        z-index: 1;
    }

    @media(max-width: 768px) {
        .widget-wrapper {
            width: auto;
        }

        .widget {
            width: 100%;
            min-width: 320px;
            transform: none;
        }
    }
</style>
